<template>
  <div class="text-center my-16">
    <div
      class="mx-auto max-w-3xl bg-[#f0f5f4] rounded-2xl p-8 md:p-12 shadow-lg"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <h3
        class="text-3xl md:text-4xl lg:text-5xl font-bold text-[#164364] mb-4 md:mb-6"
      >
        Ready to join our growing community?
      </h3>
      <p
        class="text-lg md:text-2xl text-gray-800 mb-6 md:mb-10 max-w-2xl mx-auto"
      >
        Connect with thousands of farmers and agricultural businesses already
        thriving on our platform.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CTASection",
};
</script>
